import {
    DropDown,
    Popover,
    requiredRule,
    ValidatedDropDownList,
    ValidatedInput,
} from '@finbeat/react-toolkit';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { changeOperator } from 'axios/orderApi';
import useApi from 'hooks/useApi';
import { OrderOperatorChange } from 'models/api/order';
import { useOrderLists } from 'providers/OrderListsProvider';
import { Trans, useTranslation } from 'react-i18next';

type OrderChangeOperatorPopoverProps = {
    orderId: string;
    operatorId: string;
};

const OrderChangeOperatorPopover = (props: OrderChangeOperatorPopoverProps) => {
    const { operators } = useOrderLists();
    const { t } = useTranslation();
    const api = useApi();

    const operatorsList = operators.map<DropDown>(({ id, firstName, lastName }) => ({
        id: id,
        name: `${firstName} ${lastName}`,
    }));

    return (
        <Popover<OrderOperatorChange>
            label={'change'}
            textStyle={'info'}
            buttonIcon={faUser}
            buttonLabel={'BackOfficeChangeOperator'}
            orderId={props.orderId}
            mutationFunction={(data) => changeOperator(api, data)}
            canSave={true}
            refetchQueryKeys={[['order']]}
            defaultValues={{
                OrderId: props.orderId,
                Dsc: '',
            }}
            header={
                <>
                    <Trans i18nKey={'BackOfficeChangeOperator'} /> #{props.orderId}
                </>
            }
        >
            <ValidatedDropDownList<OrderOperatorChange>
                items={operatorsList}
                name="UserId"
                label={t('BackOfficeOperator')}
                isClearable={false}
                menuPortalTarget={null}
                rules={{
                    required: requiredRule,
                }}
            />
            <ValidatedInput<OrderOperatorChange>
                id="info-comment-field"
                name="Dsc"
                type="textarea"
                label={t('BackOfficeComment')}
            />
        </Popover>
    );
};

export default OrderChangeOperatorPopover;
